<template>
	<div class="soludetail">
		<div class="img">
			<img :src="banner"/>
		</div>
		<!--路径-->
		<div class="container">
			<div class="path">
				<el-breadcrumb separator-class="el-icon-arrow-right">
				  	<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				  	<el-breadcrumb-item :to="{ path: '/Solution' }">方案中心</el-breadcrumb-item>
				  	<el-breadcrumb-item>{{data.title}}</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			
			<!--内容-->
			<div class="content clearfix">
				<div class="content-title">
					<h1>{{data.title}}</h1>
					<p class="clearfix">
						<span class="time">{{data.addtime}}</span>
						<span class="view">浏览量：{{data.views}}</span>
					</p>
				</div>
				
				<div class="content-lists" v-html="data.content"></div>
				
			</div>
			
		</div>
	</div>
</template>

<script>
	export default {
		name:'',
		components:{},
		data(){
			return{
				data:[],
				title:'',
				banner:''
			}
		},
		methods:{
			getBanner(){
				this.axios({
					method: 'get',
					url: this.GLOBAL.getBannerApi+'4',
					data: {}
				})
				.then((res) => {
					this.banner = res.data.data.banner4;
				})
				.catch((err) => {
					console.log(err)
				})
			},
			getDetail(){
				var id = this.$route.query.id;
				this.axios({
					method: 'get',
					url: this.GLOBAL.solutionGetDetailApi+id,
					data: {}
				})
				.then((res) => {
					this.data = res.data.data;
					console.log(this.data);
				})
				.catch((err) => {
					console.log(err)
				})
			}
		},
		created(){
			this.getBanner();
			this.getDetail();
		}

	}
</script>

<style lang="less" scoped="scoped">
@import url("../../../styles/main.less");
.soludetail{
	.img{
		width:100%;
		overflow:hidden;
		position:relative;
		.height(300);
		img{
			width: 150%;
			height: 100%;
			position:absolute;
			left:-20%;
		}
	}
	.container{
		.padding-left(20);
		.padding-right(20);
		.path{
			.margin-top(20);
			.margin-bottom(20);
			span{
				color: #00A0FF;
			}
		}
		.content{
			.margin-top(70);
			.margin-bottom(70);
			.content-title{
				width: 100%;
				border-bottom:1px solid #eee;
				.padding-bottom(10);
				h1{
					text-align: center;
					font-weight:600;
					.margin-bottom(20);
					.padding-top(20);
				}
				p{
					span{
						color:#696969;
						.font-size(24);
					}
					.view{
						float: right;
					}
					.time{
						float: left;
					}
				}
			}
			.content-lists{
				overflow:hidden;
				width:100%;
				.margin-top(20);
			}
		}
	}
	
}
</style>


// WEBPACK FOOTER //
// src/components/pages/Solution/SoluDetail.vue